import { Dropdown, MenuProps } from "antd";
import "./style.scss";
import { DotsMenu } from "../../../Icons/DotsMenu";
// import { DeleteConfirmation } from "../AddProviders/DeleteModal";
import { useState } from "react";

export const UserCards = ({ data, deleteItem, onCardClick, isEdit }: any) => {
  const { phone, email, firstName, lastName, id } = data || {};
  const [isDeleteView, setIsDeleteView] = useState<boolean>();

  const items: MenuProps["items"] = [
    {
      label: (
        <p className="menu-item edit" onClick={() => onCardClick(data)}>
          Edit
        </p>
      ),
      key: "3",
    },
    {
      type: "divider",
    },
    {
      label: (
        <p className="menu-item Delete" onClick={() => setIsDeleteView(true)}>
          Delete
        </p>
      ),
      key: "0",
    },
  ];

  return (
    <div className={`user-card-wrapper ${isEdit ? "active-card" : ""}`}>
      <div className="user-img-avatar">
        <div className="user-avatar">
          <span>{firstName?.charAt(0)}</span>{" "}
          <span>{lastName?.charAt(0)} </span>
        </div>
      </div>
      <div className="user-derails">
        <p>
          {firstName} {lastName}
        </p>
        <span>{email}</span>
        <span>{phone}</span>
      </div>

      <div className="branch-menu-action">
        <Dropdown menu={{ items }} trigger={["click"]}>
          <span style={{ cursor: "pointer" }}>
            <DotsMenu />
          </span>
        </Dropdown>
      </div>

      {/* {isDeleteView && (
        <DeleteConfirmation
          onCloseModal={() => setIsDeleteView(false)}
          provider={{ name: { en: firstName }, logoUrl: "" }}
          onDelete={() => deleteItem(id)}
          title="User"
        />
      )} */}
    </div>
  );
};
